export default __webpack_public_path__ + "static/media/1_0072.497ed581.webp";